import { GLOSSARY_ART_IMAGES } from "@/lib/glossary-art-images.generated";

/**
 * 用語の頁に出す「絵だけ」の版 (共有の絵 OGP と同じ絵から字とロゴと判子を外した 704x370 の webp)。
 * 表に無い用語は何も出さない。装飾なので alt は空。幅は表示の 2 倍までの大きさで書き出してある。
 * small は札に添える小さい版 (128x68)。大きい版を縮めて出すと、1 枚 7 から 17KB の絵を 64px の窓に読ませてしまう。
 * eager は用語の頁の頭の 1 枚だけ (SSR は lazy でない img を全部先読みするので、札の並びは lazy のまま)
 */
export function GlossaryArt({
  slug,
  eager = false,
  small = false,
  className,
}: {
  slug: string;
  eager?: boolean;
  small?: boolean;
  className?: string;
}) {
  const full = GLOSSARY_ART_IMAGES[slug];
  if (!full) return null;
  const src = small ? full.replace(/\.webp$/, "-s.webp") : full;
  return (
    <img
      src={src}
      alt=""
      width={small ? 128 : 704}
      height={small ? 68 : 370}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : "low"}
      decoding="async"
      aria-hidden="true"
      className={className}
    />
  );
}
